import type { MissionDetail, MissionTaskSummary } from "@/services/api/agentic-v2";

/** Synthetic stage key for timeline refs / scroll — not a template stage name. */
export const TIMELINE_LEGACY_STAGE_KEY = "__ani_timeline_legacy__";

/** True when any task has a non-empty `stage` (per-task bucketing is authoritative). */
export function missionUsesPerTaskStageGrouping(
  tasks: MissionTaskSummary[]
): boolean {
  return tasks.some((t) => t.stage != null && String(t.stage).trim() !== "");
}

/**
 * Tasks for one timeline accordion: either legacy (all under `current_stage`)
 * or matched to `task.stage === stageName`, with unknown/null stages in the
 * legacy bucket when per-task grouping is active.
 */
export function tasksForMissionTimelineStage(
  mission: MissionDetail,
  stageName: string,
  usePerTaskStages: boolean
): MissionTaskSummary[] {
  if (!usePerTaskStages) {
    if (stageName === mission.current_stage) return mission.tasks;
    return [];
  }

  const known = new Set(mission.stages.map((s) => s.name));
  if (stageName === TIMELINE_LEGACY_STAGE_KEY) {
    return mission.tasks.filter((t) => {
      const s = t.stage?.trim();
      return !s || !known.has(s);
    });
  }

  return mission.tasks.filter((t) => (t.stage?.trim() ?? "") === stageName);
}

export function countLegacyTimelineTasks(mission: MissionDetail): number {
  return tasksForMissionTimelineStage(
    mission,
    TIMELINE_LEGACY_STAGE_KEY,
    true
  ).length;
}
